import * as React from 'react';
import { useLocation } from 'react-router';
import { useStaticContext } from '../context/StaticContext';
import { BaseCommonPage } from '../layout/BaseCommonPage';
import { ContactDetails } from '../layout/ContactDetails';
import { BasePageContent } from './Base';
import { ErrorDetails } from './ErrorDetails';

interface NotFoundProps {
  details?: string;
}

const NotFound: React.FC<NotFoundProps> = ({ details }) => {
  const context = useStaticContext();
  const { state } = useLocation();
  const stateFromLocation = state as {
    originalURL?: string;
    dsId?: string;
    estateId?: string;
  };

  context.status = 404;

  return (
    <BaseCommonPage>
      <BasePageContent>
        <h1>Finner ikke det du leter etter</h1>
        <p>Er du sikker på at du skrev riktig?</p>
        {stateFromLocation && stateFromLocation?.originalURL ? (
          <p>Url: {stateFromLocation?.originalURL}</p>
        ) : null}
        {stateFromLocation && stateFromLocation?.dsId ? (
          <p>ds: {stateFromLocation.dsId}</p>
        ) : null}
        {stateFromLocation && stateFromLocation?.estateId ? (
          <p>estateId: {stateFromLocation.estateId}</p>
        ) : null}
        {details ? <ErrorDetails>{details}</ErrorDetails> : null}
        <ContactDetails />
      </BasePageContent>
    </BaseCommonPage>
  );
};

export default NotFound;
